import React, {useState, useEffect, useRef} from "react";


const ProductGroupPriceInfoContainer = (
    {
        productGroupId,
    }) => {

    const productGroupIdParsed = (productGroupId ? Number.parseInt(productGroupId) : 0);
    
    const getInitialGroupId = () => {
        const hash = window.location.hash.substring(1);
        return hash ? parseInt(hash) : productGroupIdParsed;
    };
    
    const [productGroupIdFromHash, setProductGroupIdFromHash] = useState(getInitialGroupId);
    const [priceData, setPriceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const previousHash = useRef(window.location.hash);

    useEffect(() => {
        const checkHashChange = () => {
            const currentHash = window.location.hash;
            if (previousHash.current !== currentHash) {
                previousHash.current = currentHash;
                const newHash = currentHash.substring(1);

                if (newHash) {
                    setProductGroupIdFromHash(parseInt(newHash));
                } else {
                    setProductGroupIdFromHash(productGroupIdParsed);
                }
            }
        };

        const intervalId = setInterval(checkHashChange, 100);

        window.addEventListener('hashchange', checkHashChange);
        window.addEventListener('popstate', checkHashChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('hashchange', checkHashChange);
            window.removeEventListener('popstate', checkHashChange);
        };
    }, [productGroupIdParsed]);

    useEffect(() => {
        if (productGroupIdFromHash) {
            setLoading(true);
            setError(null);

            fetch(`/ajax/product-group-prices/${productGroupIdFromHash}`)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        setPriceData(data.data);
                    } else {
                        setError(data.message || 'Failed to fetch price data');
                    }
                })
                .catch(err => {
                    setError('Error fetching price data');
                    console.error('Error:', err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [productGroupIdFromHash]);

    if (!priceData || !priceData.lowPrice || !priceData.highPrice) {
        return null;
    }

    if (loading) {
        return <div className="price-info-loading">Loading prices...</div>;
    }

    if (error) {
        return <div className="price-info-error">{error}</div>;
    }

    const formatPrice = (price) => {
        return new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(price);
    };

    return (
        <table>
            <tbody>
            <tr>
                <td valign="top" colSpan="2" className="label">
                    <div style={{minHeight: '27px'}}>
                        <div className="mb-4 print-hide">
                            <p className="mb-2">
                                Prijsindicatie productrange:
                                tussen € {formatPrice(priceData.lowPrice)} en
                                € {formatPrice(priceData.highPrice)} per eenheid
                            </p>
                            <p className="mb-2">
                                Beschikbaarheid:
                                {priceData.isInStock ? (
                                    " Uit voorraad leverbaar (afhankelijk van uitvoering)."
                                ) : (
                                    " Niet uit voorraad leverbaar."
                                )}
                            </p>
                            <p className="mb-0">
                                Definitieve prijs & levertijd na inloggen en klantconditie.
                            </p>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    )
}

export default ProductGroupPriceInfoContainer;